import axios from "~/plugins/axios";

export default {
  getEnabledThroughUser(userId) {
    return axios.get(`/web_api/v1/signal_query/enabled_through_user/${userId}`)
      .then((response) => response.data);
  },

  getEnabledThroughUserDepartment(userId) {
    return axios.get(`/web_api/v1/signal_query/enabled_through_user_department/${userId}`)
      .then((response) => response.data);
  },

  detachUserFromQuery(userId, queryId) {
    return axios.get(`/web_api/v1/signal_query/${queryId}/detach/${userId}`).then((response) => response.data);
  },

  deleteSignalFromQuery(queryId) {
    return axios.delete(`/web_api/v1/signal_query/${queryId}`).then((response) => response.data);
  },

  paginate(
    filterQuery,
    orderBy = "name",
    direction = "desc",
    perPage = 15,
    page = 1,
    includes = [],
  ) {
    return axios.post("/web_api/v1/signal_query/", {
      filterQuery,
    }, {
      params: {
        orderBy,
        direction,
        perPage,
        page,
        include: includes,
      },
    }).then((response) => response.data);
  },

  get(queryId) {
    return axios.get(`/web_api/v1/signal_query/${queryId}`).then((response) => response.data);
  },
};
